import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { FacultyType } from "../../../types/Faculty";
import { get, post } from "../../../utils/axios-config";
import { FACULTIES, FACULTIES_BY_IDS_DEPARTAMENTS } from "../../../utils/constants";

export const getFaculties = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdUniversity ? { IdUniversity: data.IdUniversity } : {}),
        ...(data?.SearchTerm  ? { SearchTerm: data.SearchTerm } : {}),

    });
    const url = `${FACULTIES}?${queryParams.toString()}`;
    return await get<PagedResultsType<FacultyType>>(url)
};

export const getFacultiesByIdDepartaments = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdUniversity ? { IdUniversity: data.IdUniversity } : {}),
        ...(data?.SearchTerm  ? { SearchTerm: data.SearchTerm } : {}),
    });
    const url = `${FACULTIES_BY_IDS_DEPARTAMENTS}?${queryParams.toString()}`;
    return await post<string[],PagedResultsType<FacultyType>>(url, data?.IdsDepartaments!)
};